export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/boston-0acf831577729f2de77fe35af0911138.webp";